import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import hljs from 'highlight.js/lib/core';
import dart from 'highlight.js/lib/languages/dart';
import json from 'highlight.js/lib/languages/json';
import bash from 'highlight.js/lib/languages/bash';
import yaml from 'highlight.js/lib/languages/yaml';
import xml from 'highlight.js/lib/languages/xml';
import javascript from 'highlight.js/lib/languages/javascript';
import php from 'highlight.js/lib/languages/php';
import plaintext from 'highlight.js/lib/languages/plaintext';

hljs.registerLanguage('dart', dart);
hljs.registerLanguage('json', json);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('yaml', yaml);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('php', php);
hljs.registerLanguage('plaintext', plaintext);

document.addEventListener('DOMContentLoaded', () => {
    hljs.highlightAll();
});

// Dark mode store with localStorage persistence
Alpine.store('darkMode', {
    on: localStorage.getItem('darkMode') === 'true' ||
        (!localStorage.getItem('darkMode') && window.matchMedia('(prefers-color-scheme: dark)').matches),

    init() {
        document.documentElement.classList.toggle('dark', this.on);

        // Follow system appearance changes when user hasn't explicitly chosen
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
            if (localStorage.getItem('darkMode') === null) {
                this.on = e.matches;
                document.documentElement.classList.toggle('dark', e.matches);
            }
        });
    },

    toggle() {
        this.on = !this.on;
        localStorage.setItem('darkMode', this.on);
        document.documentElement.classList.toggle('dark', this.on);
    }
});

Alpine.plugin(collapse);

window.Alpine = Alpine;
Alpine.start();
